export type NavView = "tests" | "settings" | "help";

type NavItemSpec = {
  view: NavView;
  label: string;
};

const NAV_ITEMS: readonly NavItemSpec[] = [
  { view: "tests", label: "Studies" },
  { view: "settings", label: "Settings" },
  { view: "help", label: "Help" },
];

export function PrimaryNav({
  active,
  onSelect,
}: {
  active: NavView;
  onSelect: (view: NavView) => void;
}) {
  return (
    <nav className="top-nav" aria-label="Primary navigation">
      {NAV_ITEMS.map((item) => (
        <button
          key={item.view}
          type="button"
          className={`top-nav-item${active === item.view ? " active" : ""}`}
          aria-current={active === item.view ? "page" : undefined}
          onClick={() => onSelect(item.view)}
        >
          <span className="label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
